<template>
  <div class="omrb">
    <!-- Overlay -->
    <transition name="omrb-fade">
      <div
        v-if="sheetOpen"
        class="omrb__overlay"
        @click="closeSheet"
      />
    </transition>

    <!-- Bottom Sheet -->
    <div class="omrb__sheet" :class="{ 'omrb__sheet--open': sheetOpen }">
      <div class="omrb__handle-row">
        <div class="omrb__handle" />
      </div>
      <div class="omrb__sheet-header">
        <span class="omrb__sheet-title">Ver Resumen Solicitud</span>
        <button class="omrb__close-btn" type="button" @click="closeSheet">
          <svg-icon type="mdi" :path="mdiCloseCircleOutline" :size="24" />
        </button>
      </div>

      <div class="omrb__body">
        <template v-if="!cliente">
          <p class="omrb__placeholder">
            A medida que avances, aquí verás el detalle de tus datos, tu equipo
            y la cobertura seleccionada.
          </p>
          <img
            src="@/assets/ovg-resumen-placeholder.png"
            alt=""
            width="287"
            height="287"
            class="omrb__placeholder-img"
          />
        </template>

        <template v-else>
          <div class="omrb__group">
            <span class="omrb__group-label">Datos del Cliente:</span>
            <div class="omrb__pair">
              <span class="omrb__label omrb__label--accent">R.U.T</span>
              <span class="omrb__value">{{ cliente.rut }}</span>
            </div>
            <div class="omrb__pair">
              <span class="omrb__label">Nombre</span>
              <span class="omrb__value">{{ cliente.nombre }}</span>
            </div>
            <div class="omrb__pair">
              <span class="omrb__label">Apellido</span>
              <span class="omrb__value">{{ cliente.apellido }}</span>
            </div>
            <div class="omrb__pair">
              <span class="omrb__label">Correo Electrónico</span>
              <span class="omrb__value">{{ cliente.correo }}</span>
            </div>
            <div class="omrb__pair">
              <span class="omrb__label">Teléfono</span>
              <span class="omrb__value">{{ cliente.telefono || '—' }}</span>
            </div>
          </div>

          <template v-if="equipo">
            <hr class="omrb__separator" />
            <div class="omrb__group">
              <span class="omrb__group-label">Datos del Equipo:</span>
              <div class="omrb__pair">
                <span class="omrb__label omrb__label--accent"
                  >N° De Serie Equipo</span
                >
                <span class="omrb__value">{{ equipo.numero_serie }}</span>
              </div>
              <div class="omrb__pair">
                <span class="omrb__label">Modelo del Equipo</span>
                <span class="omrb__value">{{ equipo.modelo_nombre }}</span>
              </div>
            </div>
          </template>

          <template v-if="extension">
            <hr class="omrb__separator" />
            <div class="omrb__group">
              <span class="omrb__group-label">Extensión de Garantía</span>
              <div class="omrb__pair">
                <span class="omrb__label">{{ extension.nombre }}</span>
                <span class="omrb__value"
                  >{{ extension.vigencia_meses }} meses de cobertura</span
                >
              </div>
            </div>
          </template>

          <template v-if="proteccionesAMostrar.length">
            <hr class="omrb__separator" />
            <div class="omrb__group">
              <span class="omrb__group-label">Protección Adicional</span>
              <div
                v-for="p in proteccionesAMostrar"
                :key="p.id"
                class="omrb__pair"
              >
                <span class="omrb__value">{{ p.nombre }}</span>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>

    <!-- Trigger bar (visible when sheet is closed) -->
    <div class="omrb__bar" @click="openSheet">
      <span class="omrb__bar-label">Ver Resumen Solicitud</span>
      <font-awesome-icon icon="chevron-up" class="omrb__bar-icon" />
    </div>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiCloseCircleOutline } from '@mdi/js'

export default {
  name: 'OvgResumenMobileBar',
  components: {
    SvgIcon,
  },
  props: {
    proteccionesPreview: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      mdiCloseCircleOutline,
      sheetOpen: false,
    }
  },
  computed: {
    cliente() {
      return this.$store.getters['OVGStore/cliente']
    },
    equipo() {
      return this.$store.getters['OVGStore/equipo']
    },
    extension() {
      return this.$store.getters['OVGStore/extension']
    },
    proteccionesAMostrar() {
      return this.proteccionesPreview !== null
        ? this.proteccionesPreview
        : this.$store.getters['OVGStore/protecciones'] || []
    },
  },
  methods: {
    openSheet() {
      this.sheetOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeSheet() {
      this.sheetOpen = false
      document.body.style.overflow = ''
    },
  },
}
</script>

<style scoped>
/* El componente sólo se renderiza visualmente en mobile.
   En desktop se oculta vía media query. */
.omrb {
  display: none;
}

/* Overlay */
.omrb__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 48;
}

/* Bottom Sheet */
.omrb__sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  padding: 14px 20px 24px;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);
  max-height: 72vh;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transform: translateY(100%);
  transition: transform 0.3s ease;
  font-family: 'Noto Sans', sans-serif;
}

.omrb__sheet--open {
  transform: translateY(0);
}

.omrb__handle-row {
  display: flex;
  justify-content: center;
  padding-bottom: 4px;
}

.omrb__handle {
  width: 50px;
  height: 6px;
  background: #e3e3e3;
  border-radius: 100px;
}

.omrb__sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.omrb__sheet-title {
  font-size: 16px;
  font-weight: 700;
  color: #23201c;
}

.omrb__close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: #525252;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
}

/* Sheet body — scrollable */
.omrb__body {
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 4px;
}

.omrb__placeholder {
  font-size: 14px;
  color: #525252;
  margin: 0;
  line-height: 1.5;
}

.omrb__placeholder-img {
  align-self: center;
  width: 287px;
  height: 287px;
  object-fit: contain;
}

.omrb__group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.omrb__group-label {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
}

.omrb__pair {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.omrb__label {
  font-size: 14px;
  font-weight: 700;
  color: #525252;
}

.omrb__label--accent {
  color: #1d4ed8;
}

.omrb__value {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
}

.omrb__separator {
  border: none;
  border-top: 1.5px solid #525252;
  margin: 0;
}

/* Trigger bar */
.omrb__bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 49;
  background: #f5f6fa;
  border-radius: 16px 16px 0 0;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-family: 'Noto Sans', sans-serif;
  -webkit-tap-highlight-color: transparent;
}

.omrb__bar-label {
  font-size: 16px;
  font-weight: 700;
  color: #23201c;
}

.omrb__bar-icon {
  font-size: 20px;
  color: #23201c;
}

/* Transitions */
.omrb-fade-enter-active,
.omrb-fade-leave-active {
  transition: opacity 0.25s ease;
}
.omrb-fade-enter,
.omrb-fade-leave-to {
  opacity: 0;
}

/* Show only on mobile */
@media (max-width: 767px) {
  .omrb {
    display: block;
  }
}
</style>
